import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { ListingsHeader } from 'src/components/organisms/ListingsHeader/ListingsHeader';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectActiveFacets,
  selectTotalActiveOptions,
} from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';

export const ListingsHeaderContainer = ({
  stickyTopBanner = false,
}: {
  stickyTopBanner?: boolean;
}) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const state = useSelector((state: ReduxApplicationState) => state);
  const activeFacets = selectActiveFacets(state);
  const totalActiveFacets = activeFacets.length;
  const totalActiveFacetOptions = selectTotalActiveOptions(state);
  const totalProducts = state.products.totalProducts;

  const openListingsControlsDrawer = () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'open modal',
      event_label: `number of categories: ${totalActiveFacets}|number of filters: ${totalActiveFacetOptions}`,
    });
    dispatch(actions.openModal());
  };

  return (
    <ListingsHeader
      onButtonClick={openListingsControlsDrawer}
      stickyOffsetPx={stickyTopBanner ? 36 : 0}
      totalActiveFacetOptions={totalActiveFacetOptions}
      totalProducts={totalProducts}
    />
  );
};
